import { REACT_APP_API } from '../../config'
import axios from 'axios'

export async function uploadProfilePicture(file) {
    let formData = new FormData()
    formData.append('file', file)
    const response = await axios.put(REACT_APP_API + "/users/updateProfilePicture", formData, { timeout: 30000 })
    return response
}
 
export async function deleteProfilePicture(fileName) {
    const response = await axios.put(REACT_APP_API + "/users/deleteProfilePicture", { profilePictureUrl: fileName})
    return response
}